import axios from 'axios';

// 应用ID - 确保这个ID正确
const APP_ID = '27dc9d32200d4a59ade097778a894605';

// 发送消息到问诊API - 使用绝对URL
export const sendMessage = async (prompt, sessionId = null) => {
  try {
    console.log('发送问诊请求:', { prompt, sessionId });
    
    // 确保请求格式正确
    const requestData = {
      prompt: prompt
    };
    
    // 如果有会话ID，添加到请求中
    if (sessionId) {
      requestData.session_id = sessionId;
    }
    
    console.log('发送到后端的请求数据:', requestData);
    
    // 使用绝对URL
    const backendUrl = 'http://localhost:5001/api/consultation';
    console.log('发送请求到:', backendUrl);
    const response = await axios.post(backendUrl, requestData);
    
    console.log('问诊响应状态:', response.status);
    console.log('问诊响应数据:', response.data);
    
    // 确保响应格式正确
    if (!response.data || !response.data.success) {
      console.error('响应格式不正确或请求不成功:', response.data);
      throw new Error(response.data?.message || '问诊失败');
    }
    
    return {
      output: response.data.output,
      session_id: response.data.session_id || sessionId
    };
  } catch (error) {
    console.error('问诊错误:', error);
    
    if (error.response) {
      console.error('响应错误状态:', error.response.status);
      console.error('响应错误数据:', error.response.data);
    }
    
    throw new Error(error.response?.data?.message || '问诊服务暂时不可用，请稍后再试');
  }
};

// 流式对话也使用相同的代理方式
export const sendStreamMessage = async (prompt, sessionId = null, onChunk, hasThoughts = false) => {
  try {
    const url = `/api/dashscope/applications/${APP_ID}/deployments/default/generation`;
    
    const payload = {
      input: {
        prompt: prompt
      },
      parameters: {
        has_thoughts: hasThoughts
      }
    };
    
    if (sessionId) {
      payload.input.session_id = sessionId;
    }
    
    // 使用EventSource实现SSE流式响应
    const eventSource = new EventSource(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        onChunk(data);
      } catch (e) {
        console.error('解析JSON出错:', e);
      }
    };
    
    eventSource.onerror = (error) => {
      console.error('流式响应错误:', error);
      eventSource.close();
      throw new Error('问诊服务连接中断，请重试');
    };
    
    return () => {
      eventSource.close();
    };
  } catch (error) {
    console.error('流式调用错误:', error);
    throw new Error(
      error.response?.data?.message || '问诊服务暂时不可用，请稍后再试'
    );
  }
};

// 创建新会话 - 确保正确处理响应
export const createNewSession = async () => {
  try {
    // 发送一个初始问候消息创建会话
    const response = await sendMessage('你好，我想咨询一些中医健康问题');
    console.log('创建会话响应:', response);
    return response.session_id;
  } catch (error) {
    console.error('创建会话失败:', error);
    return null;
  }
};

// streaming部分的修改
export const streamMessage = async (prompt, sessionId = null, hasThoughts = false, onChunk) => {
  try {
    // 更新为正确的API路径格式
    //const url = `/api/dashscope/applications/${APP_ID}/completion`;
    
    const payload = {
      input: {
        prompt: prompt
      },
      parameters: {
        has_thoughts: hasThoughts,
        incremental_output: true
      },
      debug: {}
    };
    
    if (sessionId) {
      payload.input.session_id = sessionId;
    }
    
    // 其余流式处理代码保持不变
    // ...
  } catch (error) {
    // ...
  }
}; 